import { render, staticRenderFns } from "./Landmark.vue?vue&type=template&id=5acf4f5f&scoped=true&"
import script from "./Landmark.vue?vue&type=script&lang=js&"
export * from "./Landmark.vue?vue&type=script&lang=js&"
import style0 from "./Landmark.vue?vue&type=style&index=0&id=5acf4f5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acf4f5f",
  null
  
)

export default component.exports